import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: localStorage.getItem('authToken') ? true : false, 
  user: localStorage.getItem('userProfile') ? JSON.parse(localStorage.getItem('userProfile')) : null,
  token: localStorage.getItem('authToken') || null,
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginUser: (state, action) => {
            state.isAuthenticated = true;
            state.user = {
                name: action.payload?.name,
                surname: action.payload?.surname,
                displayName: action.payload?.displayName,
                contactNo: action.payload?.contactNo,
                email: action.payload?.email
            };
            state.token = action.payload.token;
        },
        logoutUser: (state) => {
            state.isAuthenticated = false;
            state.user = null;
            state.token = null;

            //Clear Storage
            localStorage.removeItem('bookingDateFilters');
            localStorage.removeItem('selectedBusiness');
            localStorage.removeItem('businessList');
            localStorage.removeItem('authToken');
            localStorage.removeItem('userProfile');
        }
    }
});

export const { loginUser, logoutUser } = authSlice.actions;
export default authSlice.reducer;